export default __webpack_public_path__ + "static/strategy_allocation_img-cb5634c7c742bec9a543d9717980ed00.png";